import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Form, Select } from 'grab-ui';

import css from './select-field.less';

const cx = classnames.bind(css);
const Option = Select.Option;
const FormItem = Form.Item;

const SelectField = ({
  id,
  placeholder,
  options,
  className,
  dropdownClassName,
  optionClassName,
  disabled,
  fieldClassName,
  fieldOptions,
  form,
  onChange,
  extraProps,
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem className={cx('formItem', fieldClassName)}>
      {getFieldDecorator(id, fieldOptions)(
        <Select
          placeholder={placeholder}
          className={cx('select', className)}
          dropdownClassName={cx('selectDropdown', dropdownClassName)}
          disabled={disabled}
          onChange={onChange}
          {...extraProps}
        >
          {options.map(option => (
            <Option
              className={cx('selectOption', optionClassName)}
              key={option.value}
              value={option.value}
              title={option.title}
              disabled={option.disabled}
            >
              {!!option.icon && (
                <img
                  className={css.iconOption}
                  src={option.icon}
                  alt={option.title}
                />
              )}
              {option.child}
            </Option>
          ))}
        </Select>,
      )}
    </FormItem>
  );
};

SelectField.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      child: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    }),
  ),
  className: PropTypes.string,
  dropdownClassName: PropTypes.string,
  optionClassName: PropTypes.string,
  disabled: PropTypes.bool,
  fieldClassName: PropTypes.string,
  fieldOptions: PropTypes.shape({}),
  form: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func,
  extraProps: PropTypes.shape({}),
};

SelectField.defaultProps = {
  placeholder: '',
  options: [],
  className: '',
  dropdownClassName: '',
  optionClassName: '',
  disabled: false,
  fieldClassName: '',
  fieldOptions: {},
  onChange: () => {},
  extraProps: undefined,
};

export default SelectField;
